import React from 'react';
import { Alert } from '@shared/components';

interface CompletionErrorAlertProps {
    /** The completion failure to explain, or null when there is none.
     *  Sourced from QuoteWizard's useCompleteSale instance — see the plan's D3
     *  for why this must not be mounted inside renderCurrentStep(). */
    message: string | null;
}

/**
 * #876. The standing explanation for a refused completion.
 *
 * MOUNT POINT IS LOAD-BEARING: QuoteWizard renders this outside
 * renderCurrentStep(), so it survives the setCurrentStep dispatch that put the
 * user on the routed step. Moving it into a step component reverts the fix
 * while leaving every "does the message render" assertion green.
 *
 * #856 Slice B owns this file's contents from here: per-field messages, the
 * failing step's name, "you were sent here because…" copy, and any dismiss
 * affordance are all edits inside this component. Slice B does not need to
 * reopen QuoteWizard, useCompleteSale or QuoteSummaryStep.
 */
export const CompletionErrorAlert: React.FC<CompletionErrorAlertProps> = ({ message }) => {
    if (!message) return null;

    return (
        <Alert variant="error">
            <p className="font-medium">{message}</p>
        </Alert>
    );
};
